<div class="app-container">
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="container-fluid">
      <a class="navbar-brand" routerLink="/">
        <a class="navbar-brand" href="/">
          <img src="/assets/img/logo.png" alt="" width="150">
        </a>
      </a>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
          <li class="nav-item p-lg-4">
            <a class="nav-link" [class.active]="url === '/'" aria-current="page" routerLink="/">Home</a>
          </li>
          <li class="nav-item p-lg-4">
            <a class="nav-link" [class.active]="url === '/accommodation'" routerLink="/accommodation">Accommodation</a>
          </li>
          <li class="nav-item p-lg-4">
            <a class="nav-link" [class.active]="url === '/contact'" routerLink="/contact">Contact</a>
          </li>
          @if (!permissionsService.user) {
            <li class="nav-item p-lg-4">
              <a class="nav-link" [class.active]="url === '/login'" routerLink="/login">Login</a>
            </li>
          }
        </ul>
        @if (permissionsService.user) {
          <div class="nav" [class.active]="url === 'my-account'">
            <ul class="navbar-nav nav">
              <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                  Account
                </a>
                <ul class="dropdown-menu">
                  <li><a class="dropdown-item" routerLink="/my-account" data-toggle="collapse" data-target=".navbar-collapse.show">My Account</a></li>
                  <li><hr class="dropdown-divider"></li>
                  <li><a class="dropdown-item" routerLink="/my-account/orders" data-toggle="collapse" data-target=".navbar-collapse.show">Orders</a></li>
                  <li><hr class="dropdown-divider"></li>
                  <li><a class="dropdown-item" routerLink="/my-account/security" data-toggle="collapse" data-target=".navbar-collapse.show">Security</a></li>
                  <li><hr class="dropdown-divider"></li>
                  <li><a class="dropdown-item" [ngStyle]="{ cursor: 'pointer' }" (click)="logout()">Logout</a></li>
                </ul>
              </li>
            </ul>
          </div>
        }
      </div>
    </div>
  </nav>
  <router-outlet></router-outlet>
</div>
